// extracted by mini-css-extract-plugin
export default {"postContent":"Posts_postContent__-qeV2"};